import { useSiteMetadata } from "../../../../src/hooks/use-site-metadata";
import * as React from 'react';
export default {
  useSiteMetadata,
  React
};